const dedup = (arr: any[]) => {
  return Array.from(new Set(arr))
}

export default dedup
